export default "__VITE_ASSET__82b0bec9__"